










import {Component, Prop, Vue} from 'vue-property-decorator';
import BookletTile from '@/components/ui/BookletTile.vue';
import BoxTile from '@/components/ui/BoxTile.vue';
import {SET_LAYOUT_CONFIG} from "@/store/layout_module";

@Component({
    components: {
        BoxTile,
        BookletTile
    }
})
export default class Booklets extends Vue {

    private booklets: any[] = [];

    public updatePageTitle() {
        this.$store.commit('layout/' + SET_LAYOUT_CONFIG, {
            showPageTitle: true,
            showBackButton: false,
            pageTitle: 'BOOKLETS.PAGE_TITLE',
            pageTitleParams: null,
            backButtonLink: null,
            showFooterNav: false
        })
    }

    private updated() {
        this.booklets = this.$store.state.booklets;
       // this.updatePageTitle();
    }

    private mounted() {
        this.booklets = this.$store.state.booklets;
       // this.updatePageTitle();
    }

}
